import { render, staticRenderFns } from "./ModalProducts.vue?vue&type=template&id=2a5b0bca&"
import script from "./ModalProducts.vue?vue&type=script&lang=js&"
export * from "./ModalProducts.vue?vue&type=script&lang=js&"
import style0 from "./ModalProducts.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SlideShow: require('/var/www/ep-web/components/SlideShow.vue').default,AttributesCheckbox: require('/var/www/ep-web/components/AttributesCheckbox.vue').default})
